export default __webpack_public_path__ + "static/media/rotate.273c17a2.svg";